import React, { useCallback, useContext, useState } from 'react';
import style from './style';
import EADataGrid from '../../../../components/common/datatable/EADataGrid';
import { contextModelListColumns } from './ContextModelListColumns';
import ContextModel from '../ContextModel';
import { Context } from '../../../../states/Store';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '../../../../config/Config';
import {
  deleteContextModel,
  saveContextModelStatus,
} from '../../../../services/edge/ContexteService';
import {useAlert} from "../../../../components/common/hooks/useAlert";
import {Trans} from "react-i18next";
import { Typography } from '@mui/material';
import TitleWithIcon from '../../../../components/common/TitleWithIcon';
import i18next from 'i18next';
import { RoleBasedAccessControlContext } from '../../../../services/common/RolesUtils';

const ContextModelList = ({ contextModelList, onValidateSuccess }) => {
  const { classes } = style();
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);
  const history = useHistory();
  const location = useLocation();
  const [state, dispatch] = useContext(Context);
  const {onWarning, onSuccess} = useAlert();
  const [contextModelSelectedIds, setContextModelSelectedIds] = useState([]);
  const [filterRowCount, setFilterRowCount] = useState(0);
  const queryUtil = useQuery();
  const urlModelId = parseInt(queryUtil.get('model'));
  const findContextModel = () => {
    return contextModelList.find((c) => c.id === urlModelId) || null;
  };
  const [editedContext, setEditedContext] = useState(findContextModel());
  const [isReadOnly, setIsReadOnly] = useState(false);

  const openContextModel = (editedContext) => {
    setEditedContext(editedContext);
    const searchParams = queryUtil;
    searchParams.set('model', editedContext.id);

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const openReadContextModel = (editedContext) => {
    setIsReadOnly(true);
    setEditedContext(editedContext);
    const searchParams = queryUtil;
    searchParams.set('model', editedContext.id);

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const closeContextModel = () => {
    setIsReadOnly(false);
    setEditedContext(null);
    const searchParams = queryUtil;
    searchParams.delete('model');

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const changeModelStatus = useCallback(
    async ({ contextModelId, status }) => {
      const changeModel = contextModelList.find((c) => c.id === contextModelId);
      const name = changeModel.name;
      if(status) {
        onSuccess(<Trans i18nKey="demandes.contextModel.notifications.activated"><b>{{name}}</b></Trans>)
      } else {
        onWarning(<Trans i18nKey="demandes.contextModel.notifications.deactivated"><b>{{name}}</b></Trans>)
      }
      await saveContextModelStatus(
        state.account.id,
        { contextModelId, status },
        dispatch
      );
      onValidateSuccess();
    },
    [state.account.id, contextModelList, dispatch, onSuccess, onValidateSuccess, onWarning]
  );

  const deleteModel = useCallback(
    async (contextModelId) => {
      await deleteContextModel(state.account.id, contextModelId);
      const deletedContext = contextModelList.find((c) => c.id === contextModelId);
      const name = deletedContext.name;
      onSuccess(<Trans i18nKey="demandes.contextModel.notifications.deleted"><b>{{name}}</b></Trans>)
      onValidateSuccess();
    },
    [state.account.id,contextModelList, onSuccess, onValidateSuccess]
  );

  return (<>
    <Typography variant="h3">
      <TitleWithIcon
        title={i18next.t("context.contextModel")}
        icon={"context/contextModel/titleIcon"}
        resultCount={filterRowCount}
        totalCount={contextModelList?.length}
        variant={"accordion"}
        disabled={false}
      />
    </Typography>
    <div className={classes.root}>
      <EADataGrid
        loading={false}
        inputRows={contextModelList}
        getRowId={(row) => row.name}
        columns={contextModelListColumns({
          openContextModel,
          openReadContextModel,
          changeModelStatus,
          deleteModel,
          hasAnyOfPrivileges
        })}
        customSx={{
          '& .MuiDataGrid-columnHeader:nth-child(2)': { color: '#7E7E8F' },
        }}
        selection={{
          items: contextModelSelectedIds,
          setItems: setContextModelSelectedIds,
        }}
        onStateChange={(e) => {
          setFilterRowCount(e.pagination.rowCount);
        }}
        hasCustomPagination
      />
      {editedContext && (
        <ContextModel
          context={editedContext}
          readOnly={isReadOnly}
          contextList={contextModelList}
          handleClose={closeContextModel}
          onValidateSuccess={() => {
            closeContextModel();
            onValidateSuccess();
          }}
        />
      )}
    </div>
  </>);
};

export default ContextModelList;
